import type {Ref} from 'react'

import type {StackSectionStackEntry} from '../../../helpers/merge-box-status-calculator/stack-section-status'
import {getEffectiveEntryLineClass} from '../../../helpers/get-effective-entry-line-class'
import {useStackMergeabilityUpdates} from '../../../hooks/use-stack-mergeability-updates'
import {EffectiveEntryStatusLabel} from './EffectiveEntryStatusLabel'
import {EffectiveEntryStatusIcon} from './EffectiveEntryStatusIcon'
import {EffectiveEntryStatus} from '../../../helpers/effective-entry-status'
import {StackEntryNavItem} from './StackEntryNavItem'
import styles from './StackList.module.css'
import {AutoMergeRangeAction} from './AutoMergeRangeAction'

export function StackMergeabilityEntryNavItem({
  entry,
  entryRef,
  tabSuffix,
  currentPullRequestId,
  autoMergeRangePullRequestCount,
  onSwitchBranch,
}: {
  entry: StackSectionStackEntry
  entryRef?: Ref<HTMLAnchorElement>
  tabSuffix: string
  currentPullRequestId: string
  autoMergeRangePullRequestCount: number
  onSwitchBranch?: () => void
}) {
  const effectiveEntryStatus = entry.effectiveEntryStatus ?? EffectiveEntryStatus.NotReady

  useStackMergeabilityUpdates({basePageDataUrl: entry.pull.url, currentPullRequestId, channels: entry.channels})

  return (
    <StackEntryNavItem
      entry={entry}
      tabSuffix={tabSuffix}
      className={getEffectiveEntryLineClass(entry)}
      isTitleMuted={entry.position === 'AFTER'}
      leadingVisual={<EffectiveEntryStatusIcon status={effectiveEntryStatus} />}
      trailingVisual={
        <span className={styles.entryStatus}>
          <EffectiveEntryStatusLabel status={effectiveEntryStatus} />
        </span>
      }
      trailingAction={
        entry.pull.isInAutoMergeRange ? (
          <AutoMergeRangeAction pullRequestCount={autoMergeRangePullRequestCount} />
        ) : undefined
      }
      entryRef={entryRef}
      isCurrent={entry.position === 'CURRENT'}
      onClick={onSwitchBranch}
    />
  )
}
